/**
 * Normalizes user-typed hex ("fff", "#A1B2C3", " a1b2c3 ") to a canonical
 * lowercase "#rrggbb", or null when the input isn't a hex color.
 */
export function normalizeHexColor(value: string): string | null {
  let t = value.trim().replace(/^#/, '')
  if (/^[0-9a-fA-F]{3}$/.test(t)) {
    t = t
      .split('')
      .map(c => c + c)
      .join('')
  }
  return /^[0-9a-fA-F]{6}$/.test(t) ? `#${t.toLowerCase()}` : null
}
